var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.992 0C7.752 0 9.984 2.232 9.984 4.992C9.984 7.752 7.752 9.984 4.992 9.984C2.232 9.984 0 7.752 0 4.992C0 2.232 2.232 0 4.992 0ZM4.99199 1.896C4.89599 1.896 4.82399 1.896 4.75199 1.92C4.67999 1.944 4.58399 1.992 4.53599 2.04C4.48799 2.088 4.43999 2.16 4.39199 2.232C4.36799 2.304 4.34399 2.4 4.34399 2.52C4.34399 2.62249 4.3615 2.68996 4.38156 2.76728L4.39199 2.808C4.41599 2.88 4.46399 2.952 4.53599 3C4.60799 3.048 4.67999 3.072 4.75199 3.096C4.82399 3.12 4.91998 3.12 4.99198 3.12H4.99199H4.99202C5.08801 3.12 5.184 3.12 5.25599 3.096C5.32799 3.072 5.39999 3.048 5.44799 3C5.49599 2.952 5.54398 2.88001 5.59198 2.80802L5.59199 2.808C5.59698 2.79303 5.60301 2.77703 5.60942 2.75999C5.63387 2.69506 5.66399 2.61506 5.66399 2.52C5.66399 2.4 5.63999 2.304 5.59199 2.232C5.56799 2.16 5.51999 2.088 5.44799 2.04C5.42652 2.02568 5.40718 2.01136 5.3887 1.99768L5.38866 1.99766C5.3452 1.96548 5.30651 1.93683 5.25599 1.92C5.18399 1.896 5.08799 1.896 4.99199 1.896ZM4.39062 8.06417V3.57617H5.61462V8.06417H4.39062Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSolid);
export default __webpack_public_path__ + "static/media/info-solid.beba923b.svg";
export { ForwardRef as ReactComponent };